module.exports = __webpack_public_path__ + "media/claim.412f7059.wav";